module.exports = __webpack_public_path__ + "img/star-full.ea9bbb15.svg";